import React, { useEffect, useState } from 'react';
import { Container } from "react-bootstrap";
import { VisualizadorImagenes } from "./VisualizadorImagenes";
import { obtenerArchivos } from "../AccionesBackend";
import {BotonRegresar} from "../BotonRegresar";

export const FlyersDigitales = () => {
    const [flyers, setFlyers] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchFlyers = async () => {
            try {
                const response = await obtenerArchivos({ seccionId: 18 });
                if (response && response.success) {
                    if (response.archivos && response.archivos.length > 0) {
                        // Transformamos los archivos recibidos al formato que utiliza VisualizadorImagenes.
                        const mappedFlyers = response.archivos.map(file => {
                            const parts = file.nombre_completo.split("_");
                            let displayTitle = file.nombre_archivo; // Valor por defecto en caso de no cumplir el formato esperado
                            if (parts.length >= 3) {
                                const timestamp = parseInt(parts[1], 10);
                                // Convertir el timestamp (en segundos) a milisegundos
                                const date = new Date(timestamp * 1000);
                                // Nombres de los meses en español
                                const monthNames = [
                                    "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
                                    "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
                                ];
                                const month = monthNames[date.getMonth()];
                                const year = date.getFullYear();

                                displayTitle = `${month} ${year}`;
                            }
                            return {
                                src: file.ruta_archivo,
                                title: displayTitle,
                                fileName: file.nombre_archivo,
                                seccionId: 18 // En `FlyersDigitales`
                            };
                        });
                        setFlyers(mappedFlyers);
                    } else {
                        setError("No se encontraron flyers digitales.");
                    }
                } else {
                    setError("Error al obtener los flyers digitales.");
                    console.error("No se pudieron obtener los flyers digitales");
                }
            } catch (err) {
                setError("Error en la conexión o en el servidor.");
                console.error("Error al obtener los flyers:", err);
            }
        };

        fetchFlyers();
    }, []);

    return (
        <section className="flyers-digitales">
            <Container>
                <div className="banner-lineamientos">
                    <BotonRegresar/>
                    <h1>Flyers Digitales</h1>
                </div>
                { error ? (
                    <p style={{ textAlign: "center", padding: "20px", color: "red" }}>{error}</p>
                ) : (
                    <VisualizadorImagenes initialImages={flyers} />
                )}
            </Container>
        </section>
    );
};
